"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessoryType = void 0;
var AccessoryType;
(function (AccessoryType) {
    AccessoryType[AccessoryType["ACCESSORY"] = 0] = "ACCESSORY";
    AccessoryType[AccessoryType["CUSTOM"] = 1] = "CUSTOM";
    AccessoryType[AccessoryType["TYRE"] = 2] = "TYRE";
})(AccessoryType = exports.AccessoryType || (exports.AccessoryType = {}));
//# sourceMappingURL=accessory.js.map